import { observer } from 'mobx-react';

import styles from './EmptyText.module.scss';

interface Props {
    text: string;
}

export const EmptyText = observer(({ text }: Props) => {
    return <div className={styles.root}>{text}</div>;
});
